import CartMenus from "../index";
import Button from "../../../../Button";
import {getI18n, useTranslation} from "react-i18next";
import {useNavigateTo} from "../../../../../hooks/useNavigateTo";

export default function CartMenusMall9(_props) {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  const lang = getI18n().language;
  
  return (
    <CartMenus shopGoodsList={_props.shopGoodsList} goodsList={_props.goodsList}>
      {(childProps) => {
        const props = { ..._props, ...childProps };
        const { visible, onClose, shopGoodsList, goodsList, checkout, totalAmount } = props;
        
        return (
          <div id="CART_MENUS"
               style={{ boxShadow: '0 2px 15px rgba(0,0,0,.3)', zIndex: 99, display: visible ? 'block' : 'none' }}
               className="top-[50px] right-0 absolute bg-white px-[12px] w-[400px] cart-menus-arrow">
            <p className="border-b border-[#eee] py-[18px] text-center text-[16px]">
              {t('购物袋')}
              <i className="iconfont icon-delete absolute right-[24px] text-[#666] cursor-pointer"
                 onClick={() => onClose(false)}/>
            </p>
            {
              goodsList.length > 0
                ? <ul className="divide-[#eee] divide-y">
                  {
                    goodsList.map((item, i) => (
                      <li className="py-[20px] flex" key={i}>
                        <div className="rounded-[10px] overflow-hidden flex-none">
                          <img src={item.mainPic} style={{ width: 88, height: 88 }}/>
                        </div>
                        <div className="flex pl-[10px] flex-col">
                          <p className="line-clamp-2" style={{ lineHeight: '18px' }}>{lang === 'en'?item.itemEnName:item.itemName}</p>
                          <p className="text-[#999] my-[5px]">{t('规格')}: {item.specName}</p>
                          <p className="text-[#999]">{t('数量')}: {item.quantity}</p>
                        </div>
                      </li>
                    ))
                  }
                </ul>
                : <div className="text-center py-[50px] text-[#666] text-[20px]">{t('你的购物车空空如也')}</div>
            }
            {
              goodsList.length > 0 &&
              <>
                <div className="border-t border-[#eee] border-b flex justify-between px-[34px] py-[22px]">
                  <p className="text-[16px]">{t('商品总价')}</p>
                  <p className="text-[20px]">${totalAmount}</p>
                </div>
                <div className="py-[22px] flex flex-col px-[22px]">
                  <Button className="rounded-[5px] bg-[#333] text-white py-[12px] mb-[15px]"
                          onClick={checkout}>{t('前往结算')}</Button>
                  <Button className="rounded-[5px] bg-[#ECBC40] py-[12px]"
                          onClick={() => navigateTo('/cart')}>
                    {t('去购物车')}
                  </Button>
                </div>
              </>
            }
          </div>
        );
      }}
    </CartMenus>
  );
}
